import { MissionType } from '../State/Player/IMission';

export interface IMissionDefinition {
    type: MissionType;
    target: number;
    coins: number;
    keys: number;
}

export const MISSIONS: IMissionDefinition[] = [
    { type: MissionType.CLEAR_CARD_HEARTS, target: 25, coins: 20, keys: 2 },
    { type: MissionType.CLEAR_CARD_HEARTS, target: 50, coins: 30, keys: 3 },
    { type: MissionType.CLEAR_CARD_HEARTS, target: 150, coins: 50, keys: 5 },
    { type: MissionType.COLLECT_STARS, target: 7, coins: 50, keys: 5 },
    { type: MissionType.COLLECT_STARS, target: 10, coins: 100, keys: 7 },
    { type: MissionType.COLLECT_STARS, target: 20, coins: 150, keys: 10 },
    { type: MissionType.WIN_LEVEL, target: 1, coins: 20, keys: 2 },
    { type: MissionType.WIN_LEVEL, target: 3, coins: 50, keys: 3 },
    { type: MissionType.WIN_LEVEL, target: 5, coins: 75, keys: 5 },
    { type: MissionType.STREAKS, target: 10, coins: 30, keys: 3 },
    { type: MissionType.STREAKS, target: 15, coins: 50, keys: 5 },
    { type: MissionType.STREAKS, target: 20, coins: 75, keys: 7 },
    { type: MissionType.CLEAR_CARD_CLUBS, target: 25, coins: 20, keys: 2 },
    { type: MissionType.CLEAR_CARD_CLUBS, target: 50, coins: 30, keys: 3 },
    { type: MissionType.CLEAR_CARD_CLUBS, target: 150, coins: 50, keys: 5 },
    { type: MissionType.CLEAR_CARD_SPADES, target: 25, coins: 20, keys: 2 },
    { type: MissionType.CLEAR_CARD_SPADES, target: 50, coins: 30, keys: 3 },
    { type: MissionType.CLEAR_CARD_SPADES, target: 150, coins: 50, keys: 5 },
    { type: MissionType.CLEAR_CARD_DIAMONDS, target: 25, coins: 20, keys: 2 },
    { type: MissionType.CLEAR_CARD_DIAMONDS, target: 50, coins: 30, keys: 3 },
    { type: MissionType.CLEAR_CARD_DIAMONDS, target: 150, coins: 50, keys: 5 },
    { type: MissionType.CLEAR_CARD_ANY, target: 100, coins: 20, keys: 2 },
    { type: MissionType.CLEAR_CARD_ANY, target: 200, coins: 30, keys: 3 },
    { type: MissionType.CLEAR_CARD_ANY, target: 300, coins: 50, keys: 5 },
    { type: MissionType.SPIN_WHEEL, target: 3, coins: 50, keys: 5 },
    { type: MissionType.USE_JOKER, target: 1, coins: 50, keys: 5 },
];
